import React from "react";
import {connect} from "react-redux";
import createReactClass from 'create-react-class';
import {PickupSiteTypes, AccountModes, JoinSteps, URLs, SubscriptionStatuses, PaymentMethod, PaymentPlans} from "../../common/constants";
import SummaryPickupSite from "../../components/summary/SummaryPickupSite";
import SummaryItems from "../../components/summary/SummaryItems";
import SummaryDistributionDate from "../../components/summary/SummaryDistributionDate";
import AccountSummaryMessage from "../../components/account/AccountSummaryMessage";
import ModalPopup from "../../components/common/ModalPopup";
import {openChangePickupSite, openChangeSubscription, openAddSubscription, setSeasonRolloverOptOut} from "../../actions/account/accountActions";
import {setPickupSite, setWaitListPickupSite} from "../../actions/common/subscriptionSummaryActions";
import {getJoinSelectedItems, getNextDeliveryDate} from "../../common/basket";
import {joinChangeItemQuantity} from "../../actions/join/joinActions";
import {getUsefulDate, isEmptyObj} from "../../common/utils";
import {setDirty} from "../../actions/common/commonActions";
import {translate} from '../../i18n/translate.js';
import {Checkbox} from "react-bootstrap";
import styles from "../../css/summary/summary.less";

const AccountSummary = createReactClass({
    getInitialState(){
        return {
            changeError:undefined
        }
    },
    isAllowedToChangeLocation() {
        return this.props.staticData.allowChangePickupSite && this.props.pickupSite
            && (this.props.staticData.allowChangePickupSiteHomeDelivery || this.props.pickupSite.type === PickupSiteTypes.REGULAR)
            && this.isAllowActions();
    },
    isAllowedToChangeLocationOneDelivery() {
        return this.props.staticData.allowChangePickupSiteOneDelivery && this.props.pickupSite
            && (this.props.staticData.allowChangePickupSiteHomeDelivery || this.props.pickupSite.type === PickupSiteTypes.REGULAR)
            && this.isAllowActions();
    },
    isAllowAddSubscription() {
        let allow = true;
        const props = this.props;
        if(!this.props.isFarmSeasonal) {
            allow = !this.props.shareSchedules.some(function (share) {
                return props.schedules.hasOwnProperty(share) && props.schedules[share].isOnce;
            });
        }
        return this.props.staticData.allowAddSubscription && this.isAllowActions() && allow;
    },
    isAllowActions() {
        return this.props.mode == AccountModes.VIEW
            && !this.props.staticData.isPastSeason && isEmptyObj(this.props.messageData);
    },
    getMessageOrDataView() {
        if(!isEmptyObj(this.props.messageData)) {
            if (this.props.messageData.status === SubscriptionStatuses.ROLLOVER_ENABLED) {
                return this.getRolloverView();
            }
            return (<AccountSummaryMessage messageData={this.props.messageData}/>);
        } else {
            return (<div>
            {
                this.props.nextDeliveryDate ?
                    <SummaryDistributionDate nextDeliveryDate={this.props.nextDeliveryDate}
                                             deliveryDateLabel="Next Distribution"/>
                    : undefined
            }</div>);
        }
    },
    onAddSubscriptionClick() {
        if (!this.props.isPreview)
            this.props.onAddSubscriptionClick();
    },
    getPreApprovalText() {
        const preApprovalText = translate("You are") + " " + translate("_assignedAutomaticPayment");
        switch (this.props.paymentMethodToken){
            case (PaymentMethod.PAYPAL_PREAPPROVE.key) :
                return preApprovalText + "PayPal";
            case (PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) :
                return preApprovalText + translate("AUTHORIZE_DOT_NET");
            case (PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key) :
                return preApprovalText + translate("ELECTRONIC_CHECK");
            default:
                return undefined;
        }
    },
    getPaymentPlanText() {
        if (!this.props.subscriptionPaymentPlan || [PaymentPlans.F, PaymentPlans.AutoRecurring, PaymentPlans.PresetRecurring].includes(this.props.subscriptionPaymentPlan.type)) {
            return undefined;
        }
        return "Payment plan: " + this.props.subscriptionPaymentPlan.title;
    },
    getAdditionsRow() {
        const showAdditions = (this.props.extraCost && isEmptyObj(this.props.messageData)) ||
            (this.props.discount && isEmptyObj(this.props.messageData));
        const preapprovalText = this.props.staticData.accountSummaryShowPaymentDetails && this.getPreApprovalText();
        const paymentPlanText = this.props.staticData.accountSummaryShowPaymentDetails && this.getPaymentPlanText();
        if (!showAdditions && !preapprovalText && !paymentPlanText)
            return undefined;
        return (
            <div>
                <div className="summary-section-title">{translate("Additions")}</div>
                {this.props.extraCost ?
                    <div className="summary-content">{this.props.extraCost}</div>
                    :
                    undefined
                }
                {this.props.discount ?
                    <div className="summary-content">{translate("Special Discount")} ({this.props.discount}%)</div>
                    :
                    undefined
                }
                {paymentPlanText &&
                    <div className="summary-content">{paymentPlanText}</div>
                }
                {preapprovalText &&
                    <div className="summary-content summary-content-slim">{preapprovalText}</div>
                }
            </div>
            )
    },
    getSummaryView() {
        return (<div className="scroll">
            {this.getMessageOrDataView()}
            {(this.props.pickupSite || this.props.mode === AccountModes.CHANGE_PICKUP_SITE) ?
                <SummaryPickupSite pickupSiteLabel={this.props.pickupSiteLabel}
                                   readOnly={this.props.mode !== AccountModes.CHANGE_PICKUP_SITE}
                                   allowRemove={this.props.mode === AccountModes.CHANGE_PICKUP_SITE}
                                   pickupSite={this.props.pickupSite}
                                   waitListSite={this.props.waitListSite}
                                   onChangePickupSiteClick={this.props.onChangePickupSiteClick}
                                   onRemovePickupSite={this.props.onRemovePickupSite}
                                   allowChangePickupSite={this.isAllowedToChangeLocation()}
                                   allowChangePickupSiteOneDelivery={this.isAllowedToChangeLocationOneDelivery()}
                                   isChangeAllowed={this.isChangeAllowed}
                                   flowType={URLs.ACCOUNT}/>
                : undefined
            }
            {this.props.selectedItems && this.props.selectedItems.length > 0 ?
                <SummaryItems staticData={this.props.staticData}
                              readOnly={this.props.mode !== AccountModes.CHANGE_SUBSCRIPTION || this.props.staticData.allowChangeFreeOptions}
                              allowChangeShares={this.props.step === JoinSteps.SHARES}
                              allowChangeOptions={this.props.step === JoinSteps.SHARES || this.props.step === JoinSteps.OPTIONS}
                              items={this.props.selectedItems}
                              isFarmSeasonal={this.props.isFarmSeasonal}
                              schedules={this.props.schedules}
                              pickupSite={this.props.pickupSite}
                              showItemDetailsLink={true}
                              includeTax={true}
                              title={"Subscription"}
                              flowType={URLs.ACCOUNT}
                              isAllowModifySubscription={this.isAllowAddSubscription()}
                              onAddSubscriptionClick={this.onAddSubscriptionClick}
                              onChangeSubscriptionClick={this.props.onChangeSubscriptionClick}
                              isChangeAllowed={this.isChangeAllowed}
                              onRemoveItem={this.props.removeItem}/>
                :
                undefined
            }
            {this.getAdditionsRow()}
        </div>);
    },
    showPopupChangeError() {
        return (<ModalPopup
            onClose={() => {
                this.setState({changeError: undefined})
            }}
            message={this.state.changeError}
            middle={{
                text: 'Close', callback: () => {
                    this.setState({changeError: undefined})
                }
            }}/>);
    },
    isChangeAllowed() {
        if(!this.props.storeClosedEndDate) {
            this.setState({changeError: undefined});
            return true;
        } else {
            const nextDeliveryDate = getUsefulDate(this.props.storeClosedEndDate);
            let error = translate("noChangeAllowed1")
                .replace("{0}", nextDeliveryDate)
                .replace("{1}", this.props.staticData.farmEmail)
                .replace("{2}", this.props.staticData.farmPhone)

            this.setState({changeError: error});
            return false;
        }
    },
    handleOptOutChange(event) {
        this.props.setSeasonRolloverOptOut(event.target.checked);
    },
    getRolloverView() {
        if (this.props.member) {
            const seasonRollOverMessageParts = (this.props.staticData.seasonRollOverMessage ||
                'Your 2024 subscription is set for automatic renewal in 2025.|Check the box to turn OFF automatic renewal.|Turn OFF automatic renewal')
                .split('|');
            return (
                <div className="account-summary-message">
                    {seasonRollOverMessageParts[0]}<br></br>
                    {seasonRollOverMessageParts[1]}<br></br>
                    <Checkbox className="input-detail-cbx"
                              checked={this.props.member.rolloverOptOut}
                              onChange={this.handleOptOutChange}>
                        <div className="input-detail-cbk-lbl">{seasonRollOverMessageParts[2]}</div>
                    </Checkbox>
                </div>
            );
        }
    },
    render() {
        return this.props.hasMultiplePickupSites ? null : (<div className="summary-container">
            <div className="summary-row" id="joinSummaryContainer">
                <div className="secured-and-summary-wrapper">
                    <div className="secured-wrapper">{translate("Secured Payment & Privacy Protection")}</div>
                    <div className="summary-title">{translate("Summary")}{this.props.season ? (' - ' + this.props.season.title) : ''}</div>
                </div>
                {this.getSummaryView()}
            </div>
            {
                !this.state.changeError ? undefined :
                    this.showPopupChangeError()
            }
        </div>);
    }
});

const mapStateToProps = state =>  {
    const account = state.account || {};
    const subscriptionSummary = state.summary || {};
    const signupData = (state.signupData || {});
    const mode = account.mode;
    let extraCost = undefined;
    let items;
    let nextDeliveryDate;
    let selectedItems = {};
    let schedules;
    const nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
    //Next delivery date should be set by the new selection of items
    if ((mode === AccountModes.CHANGE_SUBSCRIPTION || mode === AccountModes.CHANGE_SUBSCRIPTION_THANKYOU) && signupData.sharesData) {
        if (subscriptionSummary.waitListItems && signupData.sharesData.shares && signupData.sharesData.options){
            subscriptionSummary.waitListItems.map(waitlistItem => {
                let item = signupData.sharesData.shares[waitlistItem.key] || signupData.sharesData.options[waitlistItem.key];
                if (item)
                    item.waitList = true;
            })
        }
        selectedItems = getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options);
        items = selectedItems.items;
        schedules = signupData.schedules || {};
        if (items) {
            items = items.concat(selectedItems.waitlistItems);
        }
    }else {
        items = subscriptionSummary.shareItems;
        if (items) {
            items = items.concat(subscriptionSummary.waitListItems);
        }
        schedules = subscriptionSummary.schedules || {};
    }
    if(nextDeliveryDates) {
        nextDeliveryDate = getNextDeliveryDate(subscriptionSummary.pickupSite, items, schedules, nextDeliveryDates);
    } else {
        nextDeliveryDate = subscriptionSummary.nextDeliveryDate;
    }
    if ((mode == AccountModes.VIEW || mode == AccountModes.CHANGE_PICKUP_SITE) && subscriptionSummary.pickupSite && subscriptionSummary.pickupSite.extraCost > 0) {
        const extraCostLabel = (state.staticData || {}).extraCostLabel || "Extra Fuel Charge";
        const extraCostText = subscriptionSummary.pickupSite.extraCostType === 'Fixed' ? ('$' + subscriptionSummary.pickupSite.extraCost + " " +translate("per delivery")) : (subscriptionSummary.pickupSite.extraCost + '%');
        extraCost = extraCostLabel + " : " + extraCostText;
    }

    const pickupSite = subscriptionSummary.pickupSite;
    if (state.staticData.joinHideRegularPickupSiteHours && pickupSite && pickupSite.type === PickupSiteTypes.REGULAR) {
        pickupSite.deliveryHours = '';
    }

    return {
        mode: mode,
        step: signupData.step,
        isPreview: (state.staticData || {}).isPreview,
        storeClosedEndDate: subscriptionSummary.storeClosedEndDate,
        isStoreOpen: subscriptionSummary.isStoreOpen,
        staticData: state.staticData,
        isFarmSeasonal: subscriptionSummary.isFarmSeasonal,
        nextDeliveryDate: nextDeliveryDate,
        pickupSiteLabel: state.staticData.pickupSiteLabel,
        pickupSite: pickupSite,
        schedules: subscriptionSummary.schedules,
        shareSchedules: subscriptionSummary.shareSchedules,
        waitListSite: subscriptionSummary.waitListSite,
        subscriptionStatus: subscriptionSummary.status,
        subscriptionHoldReason: subscriptionSummary.holdReason,
        selectedItems: items,
        messageData: state.messageData,
        extraCost: extraCost,
        discount: subscriptionSummary.discount,
        seasons: (subscriptionSummary.seasons || []),
        singlePaymentPlans: subscriptionSummary.singlePaymentPlans,
        autoPaymentPlans: subscriptionSummary.autoPaymentPlans,
        singlePaymentMethods: subscriptionSummary.singlePaymentMethods,
        autoPaymentMethods: subscriptionSummary.autoPaymentMethods,
        hasToken: subscriptionSummary.hasToken,
        paymentMethodToken: subscriptionSummary.paymentMethodToken,
        subscriptionPaymentPlan: subscriptionSummary.paymentPlan,
        hasMultiplePickupSites: subscriptionSummary.hasMultiplePickupSites,
        member: state.memberDetails
    };
};

const mapDispatchToProps =  (dispatch) => {
    return {
        onChangePickupSiteClick: (onlyOnce) => {
            dispatch(openChangePickupSite(onlyOnce));
        },
        onRemovePickupSite: (isWaitList) => {
            if(!isWaitList) {
                dispatch(setPickupSite(null));
            } else {
                dispatch(setWaitListPickupSite(null));
            }
        },
        onAddSubscriptionClick: () => {
            dispatch(openAddSubscription());
        },
        onChangeSubscriptionClick: () => {
            dispatch(openChangeSubscription());
        },
        removeItem: (key, newQuantity) => {
            dispatch(joinChangeItemQuantity(key, newQuantity));
            dispatch(setDirty(true));
        },
        setSeasonRolloverOptOut: (isOptOt) => {
            dispatch(setSeasonRolloverOptOut(isOptOt));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSummary);


// WEBPACK FOOTER //
// ./src/containers/account/AccountSummary.js